import { BehaviorSubject, Observable } from 'rxjs';

export class BaseSelectionService<T> {
  private selectedItemSubject = new BehaviorSubject<T | null>(null);
  selectedItem$: Observable<T | null> = this.selectedItemSubject.asObservable();

  set(item: T): void {
    this.selectedItemSubject.next(item);
  }

  clear(): void {
    this.selectedItemSubject.next(null);
  }
}
